<template>
  <div>
    <div v-if="isSearchable" class="mb-4">
      <SearchBar
        inputId="contentSearchBar"
        :searchPlaceholder="`Search for a ${searchField}`"
        @onChange="onSearch"
      />
    </div>
    <CustomLabel
      v-if="inputLabel"
      :inputLabel="inputLabel"
      :inputId="inputId"
      :isMandatory="isMandatory"
    />
    <el-radio-group
      :id="inputId"
      v-model="inputValue"
      @change="onChange"
      :disabled="isDisabled"
      :size="isTabletScreen || isSmall ? 'small' : 'default'"
    >
      <el-radio-button
        v-for="radioItem in processedItems"
        v-show="radioItem.IsVisible"
        :key="radioItem.Id"
        :value="radioItem.Id"
        :label="radioItem.Name"
        :disabled="radioItem.IsDisabled"
        :class="radioItem.Name"
      />
    </el-radio-group>
    <div class="form-group" v-if="isFormField">
      <Field v-model="inputValue" :id="inputId" :name="inputId" hidden />
      <ErrorMessage :name="inputId" class="validation-message" />
    </div>
  </div>
</template>

<script lang="ts">
import CustomLabel from "@/components/input/CustomLabel.vue";
import SearchBar from "@/components/input/SearchBar.vue";
import { handleCheckboxSearch } from "@/methods/input";
import { deepCopyObject } from "@/methods/utils";
import { useSessionStore } from "@/stores/sessionStore";
import { InputOption } from "@/types/global";
import { storeToRefs } from "pinia";
import { ErrorMessage, Field } from "vee-validate";
import { PropType, defineComponent, onBeforeMount, ref } from "vue";

export default defineComponent({
  name: "CustomRadioButton",
  props: {
    inputId: { type: String, required: true },
    radioItems: { type: Array as PropType<Array<InputOption>>, required: true },
    initialValue: { type: [Number, String], default: null },
    inputLabel: { type: String },
    isMandatory: { type: Boolean, default: false },
    isSearchable: { type: Boolean, default: false },
    searchField: { type: String, default: "value" },
    isFormField: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false },
    isSmall: { type: Boolean, default: false },
  },
  components: { CustomLabel, SearchBar, ErrorMessage, Field },
  setup(props, { emit }) {
    const sessionStore = useSessionStore();
    const { isTabletScreen } = storeToRefs(sessionStore);
    const inputValue = ref(props.initialValue);
    const processedItems = ref<Array<InputOption>>();
    onBeforeMount(() => {
      processedItems.value = deepCopyObject(props.radioItems) as Array<InputOption>;
      // This is required to init IsVisible = true for all items on load
      handleCheckboxSearch(processedItems.value, "");
    });
    function onChange() {
      emit("onChange", inputValue.value);
    }
    function onSearch(searchedValue: string) {
      handleCheckboxSearch(processedItems.value, searchedValue);
    }
    return { isTabletScreen, processedItems, inputValue, onChange, onSearch };
  },
});
</script>
